import type { ReactNode } from "react";
import { Lock } from "lucide-react";
import { Card } from "@/components/ui/card";
import { useDuenoStatus } from "./useIsDueno";

export const OWNER_ONLY_MESSAGE =
  "Esta sección la administra el dueño del CRM. Si la necesitas, pídesela.";

/** Aviso claro en lugar de un error de permisos. */
export const OwnerOnlyNotice = ({
  message = OWNER_ONLY_MESSAGE,
}: {
  message?: string;
}) => (
  <Card className="flex-row items-center gap-3 p-4 text-sm text-muted-foreground">
    <Lock className="size-5 shrink-0" />
    <span>{message}</span>
  </Card>
);

/** Muestra children solo al dueño; mientras carga, nada; si no es dueño (o falla), el aviso. */
export const OwnerOnly = ({ children }: { children: ReactNode }) => {
  const status = useDuenoStatus();
  if (status === "dueno") return <>{children}</>;
  if (status === "cargando") return null;
  return (
    <div className="p-4">
      <OwnerOnlyNotice />
    </div>
  );
};
